import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import R from "ramda";
import getDisplayName from "../utils/getDisplayName";
import convertAppPathPattern from "../utils/convertAppPathPattern";
import * as actionCreators from "../actions";

const connectApplicationCards = WrappedComponent => {
  class ConnectApplicationCards extends Component {
    constructor(props) {
      super(props);
      this.state = {
        card: undefined
      };
    }

    static getDerivedStateFromProps(props, state) {
      const {
        match: {
          params: { card }
        }
      } = props;
      if (card && card !== state.card) {
        return {
          card
        };
      }
      return null;
    }

    componentDidUpdate(prevProps, prevState) {
      if (prevState.card !== this.state.card) {
        // TODO: Calculate card name by card id
        this.props.dispatchUpdateOpenedCards([this.state.card]);
      }
    }

    convertPath = card => {
      const {
        match: { path }
      } = this.props;
      return convertAppPathPattern(path, null, null, card);
    };

    handleChange = card => {
      const nextPath = this.convertPath(card);
      this.props.history.push(nextPath);
    };

    handleOpenMultiCards = list => {
      this.props.dispatchUpdateOpenedCards(list);
    };

    render() {
      return (
        <WrappedComponent
          injectedProps={{
            handleChange: this.handleChange,
            handleOpenMultiCards: this.handleOpenMultiCards
          }}
          {...this.props}
        />
      );
    }
  }

  ConnectApplicationCards.displayName = `ConnectApplicationCards(${getDisplayName(
    WrappedComponent
  )})`;

  ConnectApplicationCards.propTypes = {
    history: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    dispatchUpdateOpenedCards: PropTypes.func.isRequired
  };

  const mapDispatchToProps = {
    dispatchUpdateOpenedCards: actionCreators.updateOpenedCards
  };

  return R.compose(withRouter, connect(null, mapDispatchToProps))(
    ConnectApplicationCards
  );
};

export default connectApplicationCards;
